// apps/dashboard/src/i18n/index.ts
// i18next configuration — loaded once at app startup via import in main.tsx

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// pt-BR
import ptBRAuth from './locales/pt-BR/auth.json';
import ptBRCommon from './locales/pt-BR/common.json';
import ptBRErrors from './locales/pt-BR/errors.json';

// en-US
import enUSAuth from './locales/en-US/auth.json';
import enUSCommon from './locales/en-US/common.json';
import enUSErrors from './locales/en-US/errors.json';

// es
import esAuth from './locales/es/auth.json';
import esCommon from './locales/es/common.json';
import esErrors from './locales/es/errors.json';

export const SUPPORTED_LANGUAGES = ['pt-BR', 'en-US', 'es'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const LANGUAGE_LABELS: Record<SupportedLanguage, string> = {
  'pt-BR': 'Português (BR)',
  'en-US': 'English (US)',
  es: 'Español',
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'pt-BR',
    supportedLngs: [...SUPPORTED_LANGUAGES],
    defaultNS: 'common',
    ns: ['common', 'auth', 'errors'],
    resources: {
      'pt-BR': {
        common: ptBRCommon,
        auth: ptBRAuth,
        errors: ptBRErrors,
      },
      'en-US': {
        common: enUSCommon,
        auth: enUSAuth,
        errors: enUSErrors,
      },
      es: {
        common: esCommon,
        auth: esAuth,
        errors: esErrors,
      },
    },
    detection: {
      // 1. localStorage preference (set by user), 2. browser language
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'omniflow_language',
    },
    interpolation: {
      // React handles XSS escaping — no need for i18next to escape
      escapeValue: false,
    },
  });

export default i18n;
